import { CreateCollectionModal } from './CreateCollectionModal'

export default CreateCollectionModal
